export default {
  methods: {
    toTimestamp(date) {
      return new Date(date)
    },
    toLocaleDate(date) {
      return this.toTimestamp(date).toLocaleDateString()
    },
  },
}
